import { environment as localEnv } from './environment.local';

export const environment = {
  ...localEnv,
};
